var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-flex my-flex-direction"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"title-bar",staticStyle:{"background":"rgba(255,96,0, 0.2)","margin-top":"-40px","margin-bottom":"30px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }